import { render, staticRenderFns } from "./MapIconSchoolKolmogorova.vue?vue&type=template&id=46477e1e&scoped=true&"
import script from "./MapIconSchoolKolmogorova.vue?vue&type=script&lang=js&"
export * from "./MapIconSchoolKolmogorova.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46477e1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46477e1e')) {
      api.createRecord('46477e1e', component.options)
    } else {
      api.reload('46477e1e', component.options)
    }
    module.hot.accept("./MapIconSchoolKolmogorova.vue?vue&type=template&id=46477e1e&scoped=true&", function () {
      api.rerender('46477e1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/icons/MapIconSchoolKolmogorova.vue"
export default component.exports